import React, { useState, useEffect } from "react";
import api from "@api";
import { Form } from "@components";
import { SalesforceRoleModel } from "@api/types/salesforcerole";
import { SalesforceRoleDetail } from "./detail";
import { M_TABLE_HEADERS_SALESFORCE_ROLE } from "../constants";
import { Cell } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import { FilterType, Table } from "@components";
import { useSalesforceRoleStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportSalesforceRoles } from "@api/excel-exporters/exportSalesforceRoles";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_SALESFORCE_ROLE.ROLE_NAME },
  { data: M_TABLE_HEADERS_SALESFORCE_ROLE.IS_ACTIVE },
  { data: M_TABLE_HEADERS_SALESFORCE_ROLE.REGION },
];

export const SalesforceRole: React.FC = () => {
  const [
    salesforceRoleStore,
    setSalesforceRoleStore,
  ] = useSalesforceRoleStore();

  useEffect(() => {
    if (salesforceRoleStore.fetchList) {
      getDataList();
    }
  }, [salesforceRoleStore]);

  const form = Form.useManager<SalesforceRoleModel>({
    id: 0,
    roleName: "",
    isActive: true,
    region: "",
  });

  const [openSalesforce, setOpenSalesforceRole] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedSalesforceRole, setSelectedSalesforceRole] = useState<
    SalesforceRoleModel
  >();
  const [salesforceroleList, setSalesforceRoleList] = useState<
    SalesforceRoleModel[]
  >([]);

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    if (openSalesforce) {
      if (selectedSalesforceRole) {
        form.set(Form.target.VALUE, ["id", selectedSalesforceRole.id]);
        form.set(Form.target.VALUE, [
          "roleName",
          selectedSalesforceRole.roleName,
        ]);
        form.set(Form.target.VALUE, [
          "isActive",
          selectedSalesforceRole.isActive,
        ]);
        form.set(Form.target.VALUE, ["region", selectedSalesforceRole.region]);
      }
    }
  }, [openSalesforce]);

  function getDataList() {
    api.salesforcerole
      .getSalesforceRole()
      .then((response) => {
        setSalesforceRoleList(response);
      })
      .catch((error) => {
        console.error(`Error in fetching salesforce role ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        setSalesforceRoleStore({ fetchList: false });
      });
  }

  const isShowModal = openSalesforce ? (
    <SalesforceRoleDetail
      form={form}
      open={openSalesforce}
      onCancel={() => setOpenSalesforceRole(false)}
    />
  ) : (
    ""
  );

  function handleExport() {
    exportSalesforceRoles();
  }

  const pageName = "Salesforce Roles";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <Table
        data={salesforceroleList.map((profile: any) => ({
          cells: [
            {
              data: profile.roleName,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedSalesforceRole(profile);
                setOpenSalesforceRole(true);
              },
            },
            {
              data: profile.isActive ? "Yes" : "No",
            },
            {
              data: profile.region,
            },
          ],
          data: profile,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_SALESFORCE_ROLE.ROLE_NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_SALESFORCE_ROLE_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
